import MGRAPI from '../interceptors/MgrApi';

const baseUrl = '/tasks';

export const getTasks = (params) => MGRAPI.get(baseUrl, { params });

export const getAllTasks = (params) => MGRAPI.get(`${baseUrl}/all`, { params });

export const getTask = (taskId) => MGRAPI.get(`${baseUrl}/${taskId}`);
